// extracted by mini-css-extract-plugin
module.exports = {"container":"cash_container__B3Py2","box_code":"cash_box_code__bYDR4","btnCodeGenerator":"cash_btnCodeGenerator__2enZl"};